export default __webpack_public_path__ + "static/media/roofing-icon.75cae295.svg";